
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import WarningIcon from 'mdi-material-ui/AlertCircleOutline'
import PropTypes from 'prop-types';
import ReactPixel from 'react-facebook-pixel';


class Success extends React.Component{
  static contextTypes = {
    router: PropTypes.object
  }

  componentDidMount(){
      let value = this.props.params && this.props.params.match.value
      let userId = this.props.params && this.props.params.match.userId
      let packageId = this.props.params && this.props.params.match.packageId

      ReactPixel.trackCustom( "PurchaseUncomplited", {value, userId, packageId})
  }

  render(){
    return(
      <div style={{paddingTop:30, height:"calc(100vh - 30px)", background: "white", position:"relative"}}>
        <Grid container justify="center">

          <Grid item xs={12}>
              <Typography variant="headline" style={{paddingTop:30, fontSize: "400%", textAlign: "center"}}>PRIŠLO JE DO NAPAKE PRI PLAČILU !</Typography>
              <Typography variant="headline" style={{paddingTop:30, fontSize: "300%", textAlign: "center"}}>NAROČILO JE BILO PREKLICANO !</Typography>
          </Grid>
          <Grid item xs={12} style={{display:"flex",alignContent: "center", justifyContent: "space-between", flexDirection:"column", textAlign: "center"}}>
            <div>
              <WarningIcon style={{fontSize: "25vw"}} />
            </div>
          </Grid>
          <Grid item xs={7}>
            <div >
              <Button fullWidth  color="primary" variant="contained" onClick={()=>this.context.router.history.push('/mojestave')} style={{fontSize: 60, textAlign: "center"}}>NAZAJ</Button>
            </div>
          </Grid>
        </Grid>
      </div>

    )
  }

}

export default Success



// WEBPACK FOOTER //
// ./src/components/payments/Error.js